import { Link } from "react-router-dom";
import { Icon } from "./Icon";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="group flex items-center gap-3" aria-label="MathPortal home">
      <span className="relative grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-cyan-400 via-indigo-500 to-violet-600 shadow-lg shadow-indigo-950/60 transition group-hover:rotate-3">
        <Icon name="Compass" size={24} className="text-white" />
        <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full border-2 border-game-ink bg-amber-300" />
      </span>
      {!compact && (
        <span>
          <span className="block font-display text-lg font-bold leading-none text-white">
            Essential Math
          </span>
          <span className="mt-1 block font-retro text-[7px] tracking-widest text-amber-300">
            ADVENTURE PORTAL
          </span>
        </span>
      )}
    </Link>
  );
}
